import { entries } from '@hover/utilities';

import abcLogo from 'assets/img/logos/abc-logo.svg';
import beaconLogo from 'assets/img/logos/beacon-logo.png';
import certainteedLogo from 'assets/img/logos/certainteed-logo.svg';
import gafLogo from 'assets/img/logos/gaf-logo.png';
import jameshardieLogo from 'assets/img/logos/jameshardie-logo.svg';

interface PartnerSchema {
  id: number;
  isCobrand: boolean;
  logo: string;
  name: string;
  parentOrgCode: string | null;
  subdomain: string;
}

const partnerMap = {
  abcsupply: {
    id: 459066,
    isCobrand: true,
    logo: abcLogo,
    name: 'ABC',
    parentOrgCode: '15ec17b5-0078-4b36-95a2-391fafe87421',
    subdomain: 'abcsupply',
  },
  beacon: {
    id: 47,
    isCobrand: false,
    logo: beaconLogo,
    name: 'Beacon 3D+',
    parentOrgCode: null,
    subdomain: 'beacon',
  },
  certainteed: {
    id: 1131,
    isCobrand: false,
    logo: certainteedLogo,
    name: 'Certainteed',
    parentOrgCode: 'd4bdb2c6-852e-4673-8e9d-05f9aa271667',
    subdomain: 'certainteed',
  },
  gaf: {
    id: 1092,
    isCobrand: true,
    logo: gafLogo,
    name: 'GAF',
    parentOrgCode: '33fb5582-372b-40e5-b2c1-51597bec24c6',
    subdomain: 'gaf',
  },
  jameshardie: {
    id: 2495,
    isCobrand: true,
    logo: jameshardieLogo,
    name: 'James Hardie',
    parentOrgCode: '88585c46-9b0a-49cd-974a-7586bc5a5c47',
    subdomain: 'jameshardie',
  },
} as const satisfies Record<string, PartnerSchema>;

export type Partner = (typeof partnerMap)[keyof typeof partnerMap];

const partners = entries(partnerMap).map(([, value]) => value);

export { partners };
